import { writable } from 'svelte/store';
export function localStorageStore(key, initial, toString, toObject) {
    //const toString = (value: any):string => JSON.stringify(value, null, 2) // helper function
    //const toObject = JSON.parse // helper function
    let data;
    let storedText = localStorage.getItem(key);
    //console.log("localStorage.getItem: " + key + ", " + storedText);
    if (storedText === null) {
        localStorage.setItem(key, toString(initial)); // initialize local storage with initial value
        data = initial;
    }
    else {
        data = toObject(storedText);
    }
    const { subscribe, set, update } = writable(data); // create the underlying writable store
    return {
        subscribe,
        set: (value) => {
            //console.log("localStorage.setItem: " + key + ", " + toString(value))
            localStorage.setItem(key, toString(value)); // save also to local storage as a string
            return set(value);
        },
        update
    };
}
export function localStorageObjectStore(key, initial) {
    return localStorageStore(key, initial, (value) => JSON.stringify(value, null, 2), (text) => JSON.parse(text));
}
export function localStorageStringStore(key, initial) {
    return localStorageStore(key, initial, (value) => value, (text) => text);
}
export function localStorageMapStore(key, initial) {
    return localStorageStore(key, initial, 
    //@ts-ignore
    (value) => JSON.stringify(Object.fromEntries(value)), (text) => {
        console.log("localStorageMapStore: ", text);
        //@ts-ignore Next line is not TypeScript safe since we can't guarantee the iterator is keyType, valueType
        return new Map(Object.entries(JSON.parse(text)));
    });
}
